export default __webpack_public_path__ + "static/media/bg.min.e7a9b192.png";